// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export let UTCOffset = function (offsetHours)
{
    this.positive = offsetHours >= 0;

    let absOffsetHours = Math.abs(offsetHours);

    this.hours = Math.trunc(absOffsetHours);
    this.minutes = absOffsetHours % 1 * 60;
};

UTCOffset.padNumber = function (num, size)
{
    var str = num.toString();
    var positive = num >= 0;

    if (!positive) str = str.substring(1);

    while (str.length < size) str = "0" + str;

    return positive ? str : '-' + str;
}

UTCOffset.prototype.compareTo = function (utcOffset)
{
    return this.totalMinutes() - utcOffset.totalMinutes();
};

UTCOffset.prototype.totalMinutes = function ()
{
    var absMinutes = this.hours * 60 + this.minutes;
    return this.positive ? absMinutes : -absMinutes;
};

UTCOffset.prototype.toString = function ()
{
    var positive = this.positive;
    var hours = this.hours;
    var minutes = this.minutes;

    if (!hours && !minutes) return '';

    return (positive ? '+' : '-') +
        UTCOffset.padNumber(hours, 2) + ':' +
        UTCOffset.padNumber(minutes, 2);
};